import common from "../common";
import Scene from "./Scene";
import {calcLeftEdge, isCordova, translate} from "../utils";
import IPCarousel from "../ui/carousel/IPCarousel";
import SceneTitlePanel from "../ui/SceneTitlePanel";

export default class SelectScene extends Scene {

    constructor() {
        super();
        this._scrollSpeed = -15;
    }

    init() {
        super.init();

        this._bg = new PIXI.TilingSprite(P3.assets.texture("bg_main"), common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this.addChild(this._bg);

        this._bg.tilePosition = common.tilePosition;

        const carouselData = P3.assets.json("ip");

        this._carousel = new IPCarousel(common.ipIndex);
        this._carousel.init(carouselData);
        this._carousel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._carousel.signals.selected.once(this._onPlayButtonClick, this);
        this.addChild(this._carousel);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_small_out");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.icon = P3.assets.texture("icon_back");

        this._backButton = new P3.Button(states);
        this._backButton.signals.click.add(this._onBackButtonClick, this);
        this._backButton.clickSoundName = "sfx_click";
        this.addChild(this._backButton);

        /*
        this._sceneTitle = new SceneTitlePanel(translate("select_show"));
        this._sceneTitle.position.set(common.STAGE_WIDTH / 2, 90);
        this.addChild(this._sceneTitle);
         */

        const uiElements = [/*this._sceneTitle,*/ this._backButton];

        for (let i = 0; i < uiElements.length; i++) {
            const e = uiElements[i];
            e.visible = false;
        }
    }

    resize() {
        super.resize();
        this._backButton.position.set(calcLeftEdge() + 90, 90);
    }

    animateIn() {
        const uiElements = [this._backButton/*, this._sceneTitle*/];

        for (let i = 0; i < uiElements.length; i++) {
            const e = uiElements[i];
            e.scale.set(0.3);

            new P3.utils.TWEEN.Tween(e.scale, this._tweens)
                .delay(i * 200 + 200)
                .to({x: 1, y: 1}, 520)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .onStart(() => e.visible = true)
                .start();
        }

        this._carousel.animateIn(400);
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();
        common.tilePosition.x += this._scrollSpeed * dt;
        common.tilePosition.y -= this._scrollSpeed * dt;

        if (common.tilePosition.x < 0) {
            common.tilePosition.x = common.STAGE_WIDTH;
        }
        if (common.tilePosition.y > common.STAGE_HEIGHT) {
            common.tilePosition.y = 0;
        }

        this._bg.tilePosition = common.tilePosition.clone();
        this._carousel.update(dt);
    }

    end() {
        // this.signals.next.dispatch();
    }

    _onPlayButtonClick() {
        common.ipIndex = this._carousel.index;
        this.signals.next.dispatch(this._carousel.selected.data);
    }

    _onBackButtonClick() {
        this.signals.previous.dispatch();
    }
}